import { render, staticRenderFns } from "./ManageCustomScripts.vue?vue&type=template&id=0ed7b753"
import script from "./ManageCustomScripts.vue?vue&type=script&lang=js"
export * from "./ManageCustomScripts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports